import dayjs from 'dayjs';
import { isUserTimezoneOffsetDifferent } from '../utils/date-helpers';
import { useSchedulingLocationInfo } from './use-scheduling-location-info';

export const useIsUserOutsideOfficeTimezone = () => {
  const { accessibleLocationData } = useSchedulingLocationInfo();
  const userTimezone = dayjs.tz.guess();

  return Object.values(accessibleLocationData).some(
    ({ timezone }) => timezone && isUserTimezoneOffsetDifferent(userTimezone, timezone)
  );
};
